/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Players_Sort_VeknInputs */



/**
* | output |
* | --- |
* | "VEKN" |
*
* @param {Players_Sort_VeknInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const players_sort_vekn = /** @type {((inputs?: Players_Sort_VeknInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Players_Sort_VeknInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("VEKN")
	if (locale === "es") return /** @type {LocalizedString} */ ("VEKN")
	if (locale === "pt") return /** @type {LocalizedString} */ ("VEKN")
	if (locale === "it") return /** @type {LocalizedString} */ ("VEKN")
	return /** @type {LocalizedString} */ ("VEKN")
});